import { Theme } from '@/utils/constants';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';
import { MuiTypography } from '../material-ui';
import { FourFiveColumnContentProps } from './FourFiveColumnContent.interface';
import useStyles from './FourFiveColumnContent.styles';

const FourFiveColumnContent = ({
  title,
  columns = [],
  columnCount,
  theme = Theme.light,
  className,
}: PropsWithChildren<FourFiveColumnContentProps>) => {
  const classes = useStyles({});
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const columnStyle = {
    width: isMobile ? '100%' : `${100 / (columnCount || columns.length)}%`,
  };

  return (
    <div
      data-testid="qa-four-five-col-content"
      className={clsx(classes.root, className, `${theme}-theme`)}
    >
      {title && (
        <MuiTypography variant="overline" component="h2" className={classes.title}>
          {title}
        </MuiTypography>
      )}

      <div className={clsx(classes.columns, 'columns')}>
        {columns.map((column, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`column_${idx}`} className={clsx(classes.column, 'column')} style={columnStyle}>
            {column}
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(FourFiveColumnContent);
